module.exports = __webpack_public_path__ + "static/media/tournaments-active-active-menu-icon.8eeaf703.svg";